import React, { createContext, FC, useContext } from 'react'
import { StepSchema } from '@feedyou-ai/feedbot-schema'

type ContextState = { step?: StepSchema | null }
const StepContext = createContext<ContextState>({ step: null })

export type Props = { step: StepSchema }

const StepProvider: FC<Props> = ({ step, children }) => {
  return <StepContext.Provider value={{ step }}>{children} </StepContext.Provider>
}

export const useParentStep = () => {
  const parentStep = useContext(StepContext).step
  return parentStep
}

export const useParentStepId = () => {
  return useParentStep()?.id
}

export default StepProvider
export type StepContextProps = Props
